import request from '@/api/axiosFun'
export const getcode = () => { 
    
        return request({
            url: 'login/get_code',
            headers:{
            //   'Accept': 'image/*',
            },
         //   responseType: "arraybuffer",
            method: 'post',       
        })
};

export const get_customer_list = ($param=[]) => { 
    
    return request({
        url: 'customer/get_customer_list',
        method: 'post',  
        data:$param,     
    })
};
export const customerLock = (params) => { 
    
    return request({
        url: 'customer/customerLock',
        method: 'post',
        data:params       
    })
};

export const customerSave = (params) => { 
    
    return request({
        url: 'customer/customerSave',
        method: 'post',  
        data:params     
    })
};



export const userDelete = (userId) => { 
    
    return request({
        url: 'customer/userDelete',
        method: 'post',  
        data:{userId}    
    })
};






// WEBPACK FOOTER //
// ./src/api/customer.js